export default function video() {
  document.querySelectorAll('.video').forEach((element) => {
    const videoOverlay = element.querySelector('.video__overlay');
    const video = element.querySelector('.video__asset');

    videoOverlay.addEventListener('click', () => {
      videoOverlay.classList.add('video__overlay--playing');
      video.play();
    });
  });
}
